import { Link } from "react-router-dom";
import { NAV_LINKS } from "@/data/content";

const LOGO_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_custom-systems-3/artifacts/9l7q7y3q_Aakuant%20Ai.PNG";

const Footer = () => {
  return (
    <footer
      className="relative border-t border-white/10 pt-16 pb-8 px-6 lg:px-10"
      data-testid="footer-section"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row justify-between gap-10 lg:gap-0">
          <div className="max-w-md">
            <div className="flex items-center gap-2.5 mb-4">
              <img
                src={LOGO_URL}
                alt="Akuant Solutions"
                className="h-7 w-7 object-contain"
              />
              <span className="font-outfit font-semibold text-lg text-white">
                Akuant Solutions
              </span>
            </div>
            <p className="text-white/45 font-manrope text-sm leading-relaxed">
              Sistemas sob medida, landing pages de alta conversão e
              automações de processos para negócios que querem crescer de
              verdade.
            </p>
          </div>

          <div className="flex gap-12">
            <div>
              <p className="font-mono-accent text-xs text-white/40 uppercase tracking-widest mb-4">
                Navegação
              </p>
              <div className="flex flex-col gap-3">
                {NAV_LINKS.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="text-sm text-white/60 hover:text-[#00D2D3] transition-colors font-manrope"
                    data-testid={`footer-link-${link.href.replace("#", "")}`}
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <p className="font-mono-accent text-xs text-white/40 uppercase tracking-widest mb-4">
                Contato
              </p>
              <a
                href="#contato"
                className="text-sm text-white/60 hover:text-[#00D2D3] transition-colors font-manrope"
                data-testid="footer-form-link"
              >
                Formulário de Contato
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 items-center">
          <div className="flex items-center gap-4">
            <p className="text-xs text-white/35 font-manrope">
              &copy; {new Date().getFullYear()} Akuant Solutions. Todos os
              direitos reservados.
            </p>
            <Link
              to="/privacidade"
              className="text-xs text-white/35 hover:text-[#00D2D3] font-manrope underline underline-offset-2 transition-colors"
              data-testid="footer-privacy-link"
            >
              Política de Privacidade
            </Link>
          </div>
          <p className="text-xs text-white/35 font-manrope">
            Feito com código, café e vontade de fazer diferente.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
